<div class="container">
    <div class="row">
        <div class="col-12">
            <img src="https://static.monific.com/assets/assets-app/img/icon/img/modal_monip_resources.svg" alt="" class="d-block m-auto">
            <h3 class="cl-primary text-center my-4">Recursos disponibles de <br> <strong>{{dev?.name}}</strong></h3>

            <h3 class="fw-sbold fs-16 text-uppercase mt-5 mb-2">Desglose de gastos</h3>
            <div class="table-responsive">
            <table class="table table-bordered table-info">
                <thead class="border">
                    <tr>
                        <th>Disponible para aceptar: </th>
                        <th>
                            {{  calculateAmount | currency: '$' }}
                        </th>
                    </tr>
                </thead>
                <tbody class="border">
                    <tr>
                      <td>Comisión por fondeo:</td>
                      <td>{{dev?.commissionWithOutIVA | percent }} - {{comisionTotal | currency: '$'}}</td>
                    </tr>
                    <tr>
                      <td>IVA:</td>
                      <td>{{ 16 }} % - {{ivaTotalF | currency: '$' }}</td>
                    </tr>
                    <tr class="border final">
                        <th>Monto neto: </th>
                        <th>
                            {{ amountNetFinal | currency: '$' }}
                        </th>
                    </tr>
                </tbody>
            </table>
          </div>
          <p class="fs-16 cl-primary mt-3">¿Deseás confirmar la operación?</p>

          <div>
            <button mat-button class="invert me-0 me-lg-2 mb-3 mb-lg-0" (click)="closeModal()">Cancelar</button>
            <button mat-button class="mb-btn mt-3 mt-lg-0 ms-lg-3" (click)="acceptResources()">Aprobar</button>
          </div>

        </div>
    </div>
</div>